// extracted by mini-css-extract-plugin
export default {"coverLink":"aN-z","contentBox":"bN-z","zapposPromoContainer":"cN-z","zapposPromoGroupContainer":"dN-z","promos":"eN-z","bottom":"fN-z","top":"gN-z","right":"hN-z","left":"iN-z"};